export enum StateName {
    Start = "Start",
    Load = "Load",
    Intro = "Intro",
    Home = "Home",
    Kitchen = "Kitchen",
    Assembly = "Assembly",
    Puzzle = "Puzzle",
    Movie = "Movie",
    Monster = "Monster",
    Robot = "Robot",
}